import { useCallback, useState, type FormEvent } from 'react';
import { useBackoffice } from '@contexts/useBackoffice';
import {
  GateWrapper,
  GateCard,
  GateTitle,
  GateSubtitle,
  PasswordInput,
  SubmitButton,
  ErrorText,
} from './BackofficePasswordGate.styled';

const BackofficePasswordGate: React.FC = () => {
  const { verify, isLoading, error } = useBackoffice();
  const [password, setPassword] = useState('');

  const handleSubmit = useCallback(
    async (e: FormEvent) => {
      e.preventDefault();
      await verify(password);
    },
    [verify, password]
  );

  return (
    <GateWrapper>
      <GateCard>
        <GateTitle>Backoffice Access</GateTitle>
        <GateSubtitle>
          Enter the backoffice password to continue.
        </GateSubtitle>
        <form onSubmit={handleSubmit}>
          <PasswordInput
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            disabled={isLoading}
          />
          <SubmitButton type="submit" disabled={isLoading || !password}>
            {isLoading ? 'Verifying...' : 'Unlock'}
          </SubmitButton>
        </form>
        {error && <ErrorText>Invalid password. Please try again.</ErrorText>}
      </GateCard>
    </GateWrapper>
  );
};

export default BackofficePasswordGate;
